// Tokens de couleur exacts, repris de MyALFA Worksync Test V2/styles.css
// (:root) — utilisés partout dans src/pages/Bureau pour rester fidèles à la
// maquette réelle plutôt qu'à une estimation depuis une capture d'écran.
export const INK = "#1F1620";
export const INK_2 = "#4D3F45";
export const INK_3 = "#8A7780";
export const LINE = "#ECE5E2";
export const LINE_2 = "#DDD2CE";
export const BURGUNDY = "#6E1A36";
export const BURGUNDY_SOFT = "#8C2A4A";
export const BURGUNDY_TINT = "#F7E9EE";
export const CREAM = "#FFF6EE";
export const BG = "#FAF7F4";
export const WARN_BG = "#FFF8DC";
export const WARN_INK = "#8B6A0F";
export const OK_BG = "#DCF3E1";
export const OK_INK = "#2A6D3C";
export const BAD_BG = "#FBE3E3";
export const BAD_INK = "#B43A3A";
export const INFO_BG = "#E5EBFA";
export const INFO_INK = "#2C4FA1";
export const NEUT_BG = "#EFEAE6";
